<template>
  <div>
    <TopNav></TopNav>
    <TopSearch></TopSearch>
    <BotNav></BotNav>
    <router-view/>
    <Footer></Footer>
  </div>
</template>
<script>
  import TopNav from '../../components/header/topNav'
  import TopSearch from '../../components/header/topSearch'
  import BotNav from '../../components/header/botNav'
  import Footer from '../../components/footers'
  export default {
      components:{
          TopNav,
          TopSearch,
          BotNav,
          Footer
      },
      created () {
      }
  }
</script>

<style lang="scss" scoped>

</style>
